import { render, staticRenderFns } from "./textmessages.vue?vue&type=template&id=92c7474e&"
import script from "./textmessages.vue?vue&type=script&lang=ts&"
export * from "./textmessages.vue?vue&type=script&lang=ts&"
import style0 from "./textmessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports